module.exports = __webpack_public_path__ + "img/198-Gris Agathe Structuré.jpg";